<input type="text"
       (focus)="hasFocus.set(true)"
       (blur)="hasFocus.set(false)"
       (keydown.enter)="search()"
       (keydown.arrowdown)="onArrowDown()"
       (keydown.arrowup)="onArrowUp()"

       [formControl]="term"
       [title]="'label.searchfield' | msgKey"
       [placeholder]="'label.searchfield' | msgKey">

<div class="searchfieldTrigger" [title]="'button.search.alt' | msgKey" (click)="search()"></div>
@if (hasFocus() && autoComplete()?.length) {
	<div #autoCompleteContainer
			class="autocomplete-result"
			(mousedown)="hasFocus.set(true)"
	>
		@for (term of autoComplete(); track term) {
			<li #seachTerm
			    (mousedown)="selectAutocomplete(term)"
			    [class.focus]="current() === $index + 1"
			    [attr.data-term]="term"
			    [innerHTML]="term | navSearchHighlight:initialTerm()"
			></li>
		}
	</div>
}
